import { Controller } from '@hotwired/stimulus';

// Connects to data-controller="factorial-iframe"
export default class extends Controller {
  static values = {
    baseUrl: {
      type: String,
      default: 'https://picturepeople.factorialhr.de'
    },
    src: {
      type: String,
      default: 'https://picturepeople.factorialhr.de/embed/jobs'
    },
    width: { type: String, default: '100%' },
    height: { type: String, default: '600' },
    jobSlug: { type: String, default: '' },
    application: Boolean,
    applicationUrl: {
      type: String,
      default: 'https://picturepeople.factorialhr.de/embed/apply/'
    }
  };

  connect() {
    this.createIframe();
    this.setupMessageListener();
  }

  disconnect() {
    if (this.handleIframeMessage) {
      window.removeEventListener('message', this.handleIframeMessage);
    }
  }

  createIframe() {
    const iframe = document.createElement('iframe');
    iframe.id = 'factorial-iframe';
    iframe.src = this.getSrc(iframe);
    iframe.width = this.widthValue;
    iframe.height = this.heightValue;
    iframe.frameBorder = '0';
    iframe.setAttribute('loading', 'lazy');

    this.element.appendChild(iframe);
    this.iframe = iframe;
  }

  setupMessageListener() {
    this.handleIframeMessage = (event) => {
      if (event.origin === this.baseUrlValue && event.data?.type === 'resizeIframe') {
        this.iframe.style.height = event.data.height + 'px';
      }
    };

    window.addEventListener('message', this.handleIframeMessage);
  }

  getSrc() {
    if (this.applicationValue && this.jobSlugValue) {
      return `${this.applicationUrlValue}${this.jobSlugValue}`;
    } else {
      return this.srcValue;
    }
  }
}
